import React from 'react';

import './styles.scss';

const CustomContainer = (props) => {
  const { children } = props;
  return (
    <div className="main-container core-container">
      {children}
    </div>
  );
};

export default CustomContainer;
